import {hashKey, QueryKey} from "@tanstack/query-core";
import {
    createContext,
    PropsWithChildren,
    useCallback,
    useContext,
    useEffect,
    useRef,
    useState,
    useSyncExternalStore
} from "react";
import {
    AgentPresence,
    AgentStamp,
    AgentStub,
    Bundle,
    BundleStamp,
    JobStamp,
    KingBasura,
    RpcVerb,
    RpcVerbMap,
    ScheduledTransfer,
    setlistPacketConsumersByVerb,
    SetlistPacketResult,
    TqKey,
    Transfer,
    Tripleg,
    TriplegStub,
    TruckStamp,
    TruckStub,
    Waste,
    WasteStamp,
    WebrpcStreamLostError,
    WebrpcStreamOptions,
    WiredSetlistPacket
} from "./webrpc-client.gen.ts";
import {isEmpty} from "lodash";
import {compareAsc, isAfter, isBefore} from "date-fns";
import {Authenticator, errUnauthenticated, useAuthenticator} from "../auth/authenticator.tsx";
import {useQueryClient} from "@tanstack/react-query";
import {Veiled} from "../components/Veil.tsx";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faLink, faSignalStreamSlash} from "@fortawesome/pro-regular-svg-icons";
import {useIdle} from "@uidotdev/usehooks";
import {useNavigate} from "@tanstack/react-router";
import {z} from "zod/v4";
import {Flexidate} from "../tstzspan.ts";
import {Comparator, Ided, Listener, listenerListAdd, objectKeys, Unlistener} from "../util/arutil.tsx";
import {cmpScheduledTransfer} from "../transit/schedule.tsx";
import {isAbortError, isSpecificError, useBomb} from "../bomb/bomb.tsx";
import {usePreferences} from "../agent/usePreferences.ts";
import {fullResetEventType} from "../reset.tsx";
import {useMothership} from "../tq/tqx.tsx";

export const WasteBundleAssociation = z.object({
    id: z.string(),
    wasteId: z.string(),
    bundleId: z.string(),
    author: AgentStub,
    posted: Flexidate,
});

// const dbTables = {
//     ScheduledTransfer: "scheduled_bundle_transfer",
//     JobStamp: "job_stamp",
//     BundleStamp: "bundle_stamp",
//     WasteStamp: "waste_stamp",
//     AgentStamp: "agent_stamp",
//     TruckStamp: "truck_stamp",
//     ActiveBundle: "bundle_active",
//     ActiveWaste: "waste_active",
//     WasteBundle: "waste_bundle",
//     Transfer: "bundle_transfer",
//     Tripleg: "tripleg",
//     TriplegStub: "tripleg_stub",
//     AgentPresence: "basura:sys/presence",
//     TruckStub: "truck_stub",
//     AgentStub: "agent_stub",
//
//     Demon: "demon",
// } as const;
//
// const Pathological = z.object({
//     id: z.optional(z.string()),
// });
//
const dbPayloads = {
    scheduled_bundle_transfer: ScheduledTransfer,
    job_stamp: JobStamp,
    bundle_stamp: BundleStamp,
    waste_stamp: WasteStamp,
    agent_stamp: AgentStamp,
    truck_stamp: TruckStamp,
    bundle_active: Bundle,
    waste_active: Waste,
    waste_bundle: WasteBundleAssociation,
    bundle_transfer: Transfer,
    tripleg: Tripleg,
    tripleg_stub: TriplegStub,
    "basura:sys/presence": AgentPresence,
    truck_stub: TruckStub,
    agent_stub: AgentStub,
} as const;
//
// const payloads = {
//     ScheduledTransfer: ScheduledTransferSchema,
//     JobStamp: JobStampSchema,
//     BundleStamp: BundleStampSchema,
//     WasteStamp: WasteStampSchema,
//     AgentStamp: AgentStampSchema,
//     TruckStamp: TruckStampSchema,
//     ActiveBundle: BundleSchema,
//     ActiveWaste: WasteSchema,
//     WasteBundle: WasteBundleAssociationSchema,
//     Transfer: Transfer,
//     Tripleg: TriplegSchema,
//     TriplegStub: TriplegStubSchema,
//     AgentPresence: AgentPresenceSchema,
//     TruckStub: TruckStubSchema,
//     AgentStub: AgentStubSchema,
//     Demon: PathologicalSchema,
// } as const;

// type TableLabel = keyof typeof dbTables;
// const TableLableSchema = z.enum(objectKeys(dbTables));
// export const TableLabels = TableLableSchema.enum;
// // const foo = Tables.Tripleg;
//
type DbTableLabel = keyof typeof dbPayloads;
const DbTableLabel = z.enum(objectKeys(dbPayloads));
const DbTableLabels = DbTableLabel.enum;
//
// type DbTableFor<Table extends TableLabel> = typeof dbTables[Table];
//
// const BasePacketSchema = z.object({
//     pkid: WiredSetlistPacketSchema.shape.pkid,
//     tbl: WiredSetlistPacketSchema.shape.tbl,
//     asof: WiredSetlistPacketSchema.shape.asof,
//     tqks: WiredSetlistPacketSchema.shape.tqks,
//     path: WiredSetlistPacketSchema.shape.path.optional(),
// });
// type BasePacket<Table extends TableLabel>
//     = z.infer<typeof BasePacketSchema> & { tbl: DbTableFor<Table> };
type TableizedPacket<DbTable extends DbTableLabel> = Omit<WiredSetlistPacket, "tbl"> & { tbl: DbTable };
//
// type Payload<Table extends TableLabel> = z.infer<typeof dbPayloadSchemas[DbTableFor<Table>]>;
// type EnsureIded<Table extends TableLabel> = Payload<Table> extends { id: string } ? Table : never;
// type IdedTableLabels = {
//     [PropertyKey in TableLabel as EnsureIded<PropertyKey>]: PropertyKey;
// };
// type IdedTableLabel = keyof IdedTableLabels;
//
type DbPayload<DbTable extends DbTableLabel> = z.infer<typeof dbPayloads[DbTable]>;
// type EnsureIdedDb<DbTable extends DbTableLabel> = DbPayload<DbTable> extends { id: string } ? DbTable : never;
// type IdedDbTableLabels = {
//     [PropertyKey in DbTableLabel as EnsureIdedDb<PropertyKey>]: PropertyKey;
// };
// type IdedDbTableLabel = keyof IdedDbTableLabels;
//
//
// function isIdedDbTable(dbtn: DbTableLabel): dbtn is IdedDbTableLabel {
//     const payloadSchema = dbPayloadSchemas[dbtn];
//     const idField = "id" in payloadSchema.shape ? payloadSchema.shape["id"] : undefined;
//     return idField instanceof ZodString;
// }
//
// function isIdedTable(tn: TableLabel): tn is IdedTableLabel {
//     const dbtn = dbTables[tn];
//     return isIdedDbTable(dbtn);
// }
//
// const idedDbTables: Record<DbTableFor<IdedTableLabel>, true> = objectFromEntries(
//     objectKeys(dbTables).filter(tn => isIdedTable(tn))
//         .map(tn => [dbTables[tn], true] as const));

// type pdt = Payload<"ActiveBundle">;
// type idt = EnsureIded<"ActiveBundle">;
// type idt2 = EnsureIded<"Demon">;
//
// const NukePacketSchema = BasePacketSchema.strict();
//
// type NukePacket<Table extends TableLabel> = BasePacket<Table> & {
//     dlta?: never;
//     prev?: never;
//     next?: never;
// };
//
// function safeParseNukePacket(raw: WiredSetlistPacket): ZodSafeParseResult<NukePacket<Table>> {
//     const zprv = NukePacketSchema.safeParse(raw);
//     return zprv as ZodSafeParseResult<NukePacket<Table>>;
// }
//
// const AddPacketSchema = z.object({
//     ...BasePacketSchema.shape,
//     dlta: z.optional(z.never()),
//     prev: z.optional(z.never()),
//     next: z.looseObject({}),
// }).check(ctx => {
//     const payloadSchema = dbPayloadSchemas[ctx.value.tbl as DbTableLabel];
//     const zprv = payloadSchema.safeParse(ctx.value.next);
//     if (!zprv.success) {
//         ctx.issues.push(...zprv.error.issues);
//     }
// });
// type AddPacket<Table extends TableLabel>
//     = Omit<z.infer<typeof AddPacketSchema>, "tbl" | "next"> & { tbl: DbTableFor<Table>, next: Payload<Table> };
//
// function safeParseAddPacket<Table extends TableLabel>(raw: TableizedPacket<Table>): ZodSafeParseResult<AddPacket<Table>> {
//     const zprv = AddPacketSchema.safeParse(raw);
//     return zprv as ZodSafeParseResult<AddPacket<Table>>;
// }


// export type AddPacket<Table extends TableLabel> = BasePacket<Table> & {
//     dlta?: never;
//     prev?: never;
//     next: Payload<Table>;
// };
//
// const DelPacketSchema = z.object({
//     ...BasePacketSchema.shape,
//     dlta: z.optional(z.never()),
//     prev: IdedSchema.loose(),
//     next: z.optional(z.never()),
// });
// type DelPacket<Table extends TableLabel> = Table extends IdedTableLabel
//     ? Omit<z.infer<typeof DelPacketSchema>, "tbl"> & { tbl: DbTableFor<Table> }
//     : never;
//
// function safeParseDelPacket<Table extends TableLabel>(raw: TableizedPacket<Table>): ZodSafeParseResult<DelPacket<Table>> {
//     const zprv = DelPacketSchema.safeParse(raw);
//     return zprv as ZodSafeParseResult<DelPacket<Table>>;
// }

// export type DelPacket<Table extends TableLabel> = Payload<T> extends Ided ? BasePacket<T> & {
//     dlta?: never;
//     prev: Ided;
//     next?: never;
// } : never;

// const ReplacePacketSchema = z.object({
//     ...BasePacketSchema.shape,
//     dlta: z.optional(z.never()),
//     prev: IdedSchema.loose(),
//     next: IdedSchema.loose(),
// }).check(ctx => {
//     const payloadSchema = dbPayloadSchemas[ctx.value.tbl as DbTableLabel];
//     const prevZprv = payloadSchema.safeParse(ctx.value.prev);
//     if (!prevZprv.success) {
//         ctx.issues.push(...prevZprv.error.issues);
//     }
//     const nextZprv = payloadSchema.safeParse(ctx.value.next);
//     if (!nextZprv.success) {
//         ctx.issues.push(...nextZprv.error.issues);
//     }
//
//     const prevId = ctx.value.prev.id;
//     const nextId = ctx.value.next.id;
//     if (prevId !== nextId) {
//         ctx.issues.push({
//             code: "custom",
//             message: "prev and next ids must match",
//             values: [prevId, nextId],
//             input: ctx.value,
//         });
//     }
// });
// type ReplacePacket<Table extends TableLabel> = Table extends IdedTableLabel
//     ? Omit<z.infer<typeof ReplacePacketSchema>, "tbl" | "prev" | "next"> & {
//     tbl: DbTableFor<Table>;
//     prev: Payload<Table>;
//     next: Payload<Table>;
// } : never;
//
// function safeParseReplacePacket<Table extends TableLabel>(raw: TableizedPacket<Table>): ZodSafeParseResult<ReplacePacket<Table>> {
//     const zprv = ReplacePacketSchema.safeParse(raw);
//     return zprv as ZodSafeParseResult<ReplacePacket<Table>>;
// }


// export type ReplacePacket<Table extends TableLabel> = Payload<T> extends Ided ? BasePacket<T> & {
//     dlta?: never;
//     prev: Ided;
//     next: Payload<T>;
// } : never;

// const DeltaPacketSchema = z.object({
//     ...BasePacketSchema.shape,
//     dlta: z.literal(true),
//     prev: IdedSchema.loose(),
//     next: IdedSchema.loose(),
// }).check(ctx => {
//     const payloadSchema = dbPayloadSchemas[ctx.value.tbl as DbTableLabel];
//     const partialPayloadSchema = payloadSchema.partial();
//     const prevZprv = partialPayloadSchema.safeParse(ctx.value.prev);
//     if (!prevZprv.success) {
//         ctx.issues.push(...prevZprv.error.issues);
//     }
//     const nextZprv = partialPayloadSchema.safeParse(ctx.value.next);
//     if (!nextZprv.success) {
//         ctx.issues.push(...nextZprv.error.issues);
//     }
//
//     const prevId = ctx.value.prev.id;
//     const nextId = ctx.value.next.id;
//     if (prevId !== nextId) {
//         ctx.issues.push({
//             code: "custom",
//             message: "prev and next ids must match",
//             values: [prevId, nextId],
//             input: ctx.value,
//         });
//     }
// });
// type DeltaPacket<Table extends TableLabel> = Table extends IdedTableLabel
//     ? Omit<z.infer<typeof DeltaPacketSchema>, "tbl" | "prev" | "next"> & {
//     tbl: DbTableFor<Table>;
//     prev: Omit<Partial<Payload<Table>>, "id"> & Ided;
//     next: Omit<Partial<Payload<Table>>, "id"> & Ided;
// } : never;
//
// function safeParseDeltaPacket<Table extends TableLabel>(raw: TableizedPacket<Table>): ZodSafeParseResult<DeltaPacket<Table>> {
//     const zprv = DeltaPacketSchema.safeParse(raw);
//     return zprv as ZodSafeParseResult<DeltaPacket<Table>>;
// }


// export type DeltaPacket<Table extends TableLabel> = Payload<T> extends Ided ? BasePacket<T> & {
//     dlta: true;
//     prev: Partial<Payload<T>> & Ided;
//     next: Partial<Payload<T>> & Ided;
// } : never;

// export type SetlistPacket<Table extends TableLabel>
//     = NukePacket<Table>
//     | AddPacket<Table>
//     | DelPacket<Table>
//     | ReplacePacket<Table>
//     | DeltaPacket<Table>
//     ;

// // TODO: make sure tqks get the right table shape
// const SetlistPacketSchema = WiredSetlistPacketSchema
//     .check(ctx => {
//         if (!ctx.value.prev && !ctx.value.next) {
//             // any nuke packet is valid
//             return;
//         }
//
//         let payloadSchema;
//         if (ctx.value.tbl in payloadSchemas) {
//             payloadSchema = payloadSchemas[ctx.value.tbl as DbTable];
//         } else {
//             ctx.issues.push({
//                 code: "invalid_value",
//                 values: [ctx.value.tbl] as const,
//                 input: ctx.value,
//             });
//             return;
//         }
//
//         // additions are the only case where we do not mandate ids in the payload,
//         // so deal with those first
//         if (!ctx.value.prev && !!ctx.value.next) {
//             if (ctx.value.dlta) {
//                 ctx.issues.push({
//                     code: "custom",
//                     message: "delta packets must have both prev and next",
//                     input: ctx.value,
//                 });
//             }
//             const zprv = payloadSchema.safeParse(ctx.value.next);
//             if (!zprv.success) {
//                 ctx.issues.push(...zprv.error.issues);
//             }
//             return;
//         }
//
//         const isPayloadIdMandatory = "id" in payloadSchema.shape
//             && !isZodOptional(payloadSchema.shape.id);
//         if (!isPayloadIdMandatory) {
//             ctx.issues.push({
//                 code: "custom",
//                 message: "id required on payload",
//                 input: ctx.value,
//             });
//             return;
//         }
//
//         // at this point, we can rely on payload having a mandatory id, which is
//         // necessary for all deltas, replacements, and deletions.
//
//         if (!!ctx.value.prev && !ctx.value.next) {
//             if (ctx.value.dlta) {
//                 ctx.issues.push({
//                     code: "custom",
//                     message: "delta packets must have both prev and next",
//                     input: ctx.value,
//                 });
//             }
//             // deletion
//             const prevZprv = IdedSchema.safeParse(ctx.value.prev);
//             if (!prevZprv.success) {
//                 ctx.issues.push(...prevZprv.error.issues);
//             }
//             return;
//         }
//
//         // at this point, we can rely on both prev and next being set
//         // regardless of whether it's a delta or not, id must be set on
//         // both sides, and must match
//         const prevIdedZprv = IdedSchema.safeParse(ctx.value.prev);
//         if (!prevIdedZprv.success) {
//             ctx.issues.push(...prevIdedZprv.error.issues);
//         }
//
//         const nextIdedZprv = IdedSchema.safeParse(ctx.value.next);
//         if (!nextIdedZprv.success) {
//             ctx.issues.push(...nextIdedZprv.error.issues);
//         }
//
//         if (prevIdedZprv.success && nextIdedZprv.success && prevIdedZprv.data.id !== nextIdedZprv.data.id) {
//             ctx.issues.push({
//                 code: "custom",
//                 message: "prev and next ids must match",
//                 values: [prevIdedZprv.data, nextIdedZprv.data],
//                 input: ctx.value,
//             });
//         }
//
//         if (ctx.value.dlta) {
//             const partialPayloadSchema = payloadSchema.partial();
//             const prevZprv = partialPayloadSchema.safeParse(ctx.value.prev);
//             if (!prevZprv.success) {
//                 ctx.issues.push(...prevZprv.error.issues);
//             }
//             const nextZprv = partialPayloadSchema.safeParse(ctx.value.next);
//             if (!nextZprv.success) {
//                 ctx.issues.push(...nextZprv.error.issues);
//             }
//             return;
//         }
//
//         // final possibility is a replacement, where new must be complete. prev might not
//         // have to be, but we will require it to be so for now.
//         const prevZprv = payloadSchema.safeParse(ctx.value.prev);
//         if (!prevZprv.success) {
//             ctx.issues.push(...prevZprv.error.issues);
//         }
//         const nextZprv = payloadSchema.safeParse(ctx.value.next);
//         if (!nextZprv.success) {
//             ctx.issues.push(...nextZprv.error.issues);
//         }
//     });
//
// export function safeParseSetlistPacket<Table extends TableLabel>(raw: RawPacket<T>): ZodSafeParseResult<SetlistPacket<T>> {
//     return SetlistPacketSchema.safeParse(raw) as ZodSafeParseResult<SetlistPacket<T>>;
// }
//
// export function parseSetlistPacket<Table extends TableLabel>(raw: RawPacket<T>): SetlistPacket<T> {
//     return SetlistPacketSchema.parse(raw) as SetlistPacket<T>;
// }
//
// const BaseSetlistPacketSchema = z.looseObject({
//     pkid: z.string(),
//     tbl: DbTableSchema,
//     asof: z.string(),
//     tqks: z.string().array(),
// });
// type BaseSetlistPacket = z.infer<typeof BaseSetlistPacketSchema>;
//
// export const NukeSetlistPacketSchema
//     = BaseSetlistPacketSchema.strict().brand("nuke");
//
// export function makeAddSetlistPacketSchema<T extends Zoddable>(payloadSchema: ZodObject<T>) {
//     const rv = z.object({
//         ...BaseSetlistPacketSchema.shape,
//         next: payloadSchema.shape,
//     }).brand("add");
//     return rv;
// }
//
// export type AddSetlistPacket<Table extends SetlistTableName, PayloadT extends Zoddable>
//     = Tableized<BaseSetlistPacket & { next: PayloadT }, Table>;
//
// export const delSetlistPacketSchema = z.object({
//     ...BaseSetlistPacketSchema.shape,
//     prev: IdedSchema.shape,
// }).brand("del");
//
// export type DeletionSetlistPacket<Table extends SetlistTableName>
//     = Tableized<BaseSetlistPacket & { prev: Ided }, Table>;
//
// export function makeReplaceSetlistPacketSchema<T extends Zoddable>(payloadSchema: ZodObject<T>) {
//     const rv = z.object({
//         ...BaseSetlistPacketSchema.shape,
//         prev: payloadSchema.shape,
//         next: payloadSchema.shape,
//     }).brand("replace");
//     return rv;
// }
//
// export type ReplaceSetlistPacket<Table extends SetlistTableName, PayloadT extends Zoddable>
//     = Tableized<BaseSetlistPacket & { prev: PayloadT, next: PayloadT }, Table>;
//
// export function makeDeltaSetlistPacketSchema<T extends Zoddable>(payloadSchema: ZodObject<T>) {
//     const partialPayloadShape
//         = z.intersection(payloadSchema.partial(), IdedSchema);
//     const rv = z.object({
//         ...BaseSetlistPacketSchema.shape,
//         dlta: z.literal(true),
//         prev: partialPayloadShape,
//         next: partialPayloadShape,
//     }).brand("delta");
//     return rv;
// }
//
// export type DeltaSetlistPacket<Table extends SetlistTableName, PayloadT extends Zoddable>
//     = Tableized<BaseSetlistPacket & { dlta: true, prev: Partial<PayloadT>, next: Partial<PayloadT> }, Table>;
//
// const afo = makeDeltaSetlistPacketSchema(TriplegSchema).parse({});


//     asof: z.string(),
//     dlta: z.optional(z.never()),
//     prev: z.looseObject(IdedSchema.shape),
//     next: z.optional(z.never()),
// });
//
// const AnyReplaceSetlistPacketSchema = z.strictObject({
//     pkid: z.string(),
//     tbl: z.string(),
//     asof: z.string(),
//     tqks: z.string().array(),
//     dlta: z.optional(z.never()),
//     prev: z.looseObject({id: z.optional(z.string())}),
//     next: z.looseObject({id: z.optional(z.string())}),
// }).refine(maybe => maybe.prev.id === maybe.next.id);
//
// const AnyDeltaSetlistPacketSchema = z.strictObject({
//     pkid: z.string(),
//     tbl: z.string(),
//     asof: z.string(),
//     tqks: z.string().array(),
//     dlta: z.literal(true),
//     prev: z.looseObject(IdedSchema.shape),
//     next: z.looseObject(IdedSchema.shape),
// }).strict().refine(maybe => maybe.prev.id === maybe.next.id);

// export function makeInsertSetlistPacket<T>(payload)
//
// export type InsertSetlistPacket<DBTable extends string, T> = {
//     pkid: string;
//     tbl: DBTable;
//     asof: string;
//     tqks: string[];
//     dlta?: never;
//     prev?: null;
//     next: T;
//     $brand$: "add";
// }
//
// export type DeleteSetlistPacket<DBTable extends string> = {
//     pkid: string;
//     tbl: DBTable;
//     asof: string;
//     tqks: string[];
//     dlta?: never;
//     prev: Ided;
//     next?: null;
//     $brand$: "del";
// }
//
// export type ReplaceSetlistPacket<DBTable extends string, T extends Ided> = {
//     pkid: string;
//     tbl: DBTable;
//     asof: string;
//     tqks: string[];
//     dlta?: never;
//     prev: T;
//     next: T;
//     $brand$: "repl";
// };
//
// export type DeltaSetlistPacket<DBTable extends string, T extends Ided> = {
//     pkid: string;
//     tbl: DBTable;
//     asof: string;
//     tqks: string[];
//     dlta: true;
//     prev: Partial<T> & Ided;
//     next: Partial<T> & Ided;
//     $brand$: "delta";
// };

// type SetlistDbTableName = keyof typeof payloadSchemas;
// type SetlistPacketPayloadSchema<DBTable extends SetlistDbTableName> = z.infer<typeof payloadSchemas[DBTable]>;


// function brandSetlistPacket
//
// function parseSetlistPacket<DBTable>(raw: TabledSetlistPacket<DBTable>): FancySetlistPacket<DBTable> {
//     const loosePacket = WiredSetlistPacketSchema.parse(raw);
//
//     if (!raw.prev) {
//         if (!raw.next) {
//
//         }
//     }
// }
//
// function parseSetlistPacket<DBTable extends SetlistDbTableName>(raw: WiredSetlistPacket)
//
// const AnyDelSetlistPacketSchema = z.strictObject({
//     pkid: z.string(),
//     tbl: z.string(),
//     tqks: z.string().array(),
//
// const AnySetlistPacketSchema = z.union([
//     AnyInsSetlistPacketSchema,
//     AnyDelSetlistPacketSchema,
//     AnyNukeSetlistPacketSchema,
//     AnyReplaceSetlistPacketSchema,
//     AnyDeltaSetlistPacketSchema,
// ]);
//
// const pkt = {
//     pkid: "34",
//     tbl: "tripleg",
//     asof: "now",
//     tqks: ["hi"] as string[],
//     // dlta: true,
//     prev: {id: "12"} as const,
// } as const;
//
// const ppkt: z.infer<typeof AnySetlistPacketSchema> = pkt;
// type ppktt = typeof ppkt;
// console.log(ppkt);
//
// type anyinst = z.infer<typeof AnyInsSetlistPacketSchema>;
//
// function makeDeltableSetlistPacketSchema<
//     DbTableName extends string,
//     PayloadT extends ZodType,
//     DeltaPayloadT extends ZodType
// >(dbtn: DbTableName,
//   payloadSchema: ZodObject<PayloadT>,
//   deltaPayloadSchema?: ZodObject<DeltaPayloadT>) {
//     const nukeSchema = AnyNukeSetlistPacketSchema.extend({
//         tbl: z.literal(dbtn)
//     });
//     const insSchema = AnyInsSetlistPacketSchema.extend({
//         tbl: z.literal(dbtn),
//         next: payloadSchema.shape,
//     });
//     const delSchema = AnyDelSetlistPacketSchema.extend({
//         tbl: z.literal(dbtn),
//     });
//     const replSchema = AnyReplaceSetlistPacketSchema.extend({
//         tbl: z.literal(dbtn),
//         prev: payloadSchema.shape,
//         next: payloadSchema.shape,
//     });
//     const dltaSchema = deltaPayloadSchema
//         ? AnyDeltaSetlistPacketSchema.extend({
//             tbl: z.literal(dbtn),
//             prev: deltaPayloadSchema.shape,
//             next: deltaPayloadSchema.shape,
//         })
//         : undefined;
//
//     const schema = dltaSchema
//         ? z.union([
//             nukeSchema,
//             insSchema,
//             delSchema,
//             replSchema,
//             dltaSchema,
//         ])
//         : z.union([
//             nukeSchema,
//             insSchema,
//             delSchema,
//             replSchema,
//         ]);
//
//     return schema;
// }
//
// const bfos = makeDeltableSetlistPacketSchema(
//     "tripleg",
//     TriplegSchema,
//     TriplegDeltaSchema);
//
// type bfot = z.infer<typeof bfos>;
//
// function inferSchema<UT extends Ided, T extends Readonly<Readonly<{
//     [k: string]: z.core.$ZodType<UT, unknown, z.core.$ZodTypeInternals<UT, unknown>>;
// }>>>(schema: z4.$ZodObject<T>) {
//     return schema;
// }
//
// function afof<DbTableName extends string, UT extends Ided, ShapeT extends Readonly<{
//     [k: string]: z.core.$ZodType<UT, unknown, z.core.$ZodTypeInternals<UT, unknown>>;
// }>>(dbtn: DbTableName, payloadSchema: ZodObject<ShapeT>) {
//     const tabledSchema = z.object({
//         ...BaseSetlistPacketSchema.shape,
//         tbl: z.literal(dbtn),
//     });
//
//     const nukePacketSchema = z.object({
//         ...tabledSchema.shape,
//         dlta: z.optional(z.never()),
//         prev: z.optional(z.null()),
//         next: z.optional(z.null()),
//     })
//     const insertPacketSchema = z.object({
//         ...tabledSchema.shape,
//         dlta: z.optional(z.literal(false)),
//         prev: z.optional(z.null()),
//         next: payloadSchema,
//     });
//     const deletePacketSchema = z.object({
//         ...tabledSchema.shape,
//         dlta: z.optional(z.literal(false)),
//         prev: IdedSchema,
//         next: z.optional(z.null()),
//     });
//
//     const fullUpdatePacketSchema = z.object({
//         ...tabledSchema.shape,
//         dlta: z.optional(z.literal(false)),
//         prev: payloadSchema,
//         next: payloadSchema,
//     });
//
//     //  const deltaUpdatePacketSchema = z.object({
//     //     ...tabledSchema.shape,
//     //     dlta: z.literal(true),
//     //     prev: z.intersection(payloadSchema.partial(), IdedSchema),
//     //     next: z.intersection(payloadSchema.partial(), IdedSchema),
//     // });
//
//     const rv = z.union([
//         nukePacketSchema,
//         insertPacketSchema,
//         deletePacketSchema,
//         fullUpdatePacketSchema,
//         //       deltaUpdatePacketSchema,
//     ]);
//     return rv;
// }
//
// const afo = afof("tripleg", TriplegSchema);
// type afot = z.infer<typeof afo>;
//
// function makeIdedSetlistPacketSchema<
//     DbTableName extends string,
//     T extends Readonly<Readonly<{
//         [k: string]: z.core.$ZodType<unknown, unknown, z.core.$ZodTypeInternals<unknown, unknown>>;
//     }>>>(dbtn: DbTableName, payloadSchema: z4.$ZodObject<T>) {
//     const ips = inferSchema(payloadSchema);
//     const tabledSchema = z.object({
//         ...BaseSetlistPacketSchema.shape,
//         tbl: z.literal(dbtn),
//     });
//     const insertionPacketSchema = z.object({
//         ...tabledSchema.shape,
//         prev: ips.partial(),
//         next: ips.partial(),
//     });
//     return insertionPacketSchema;
// }
//
// const triplegPs = makeIdedSetlistPacketSchema("tripleg", TriplegSchema);
// const wastePs = makeIdedSetlistPacketSchema("waste_active", WasteSchema);
// const packetPs = z.discriminatedUnion("tbl", [
//     triplegPs, wastePs,
// ])
// type tpst = z.infer<typeof packetPs>;
// const pk1: tpst = {
//     tbl: "waste_active",
// };
//
//
// function buildSetlistPacketSchemas<
//     DbTableName extends string,
//     PayloadSchemaT extends ZodType,
//     PartialPayloadSchemaT extends ZodType>(dbTableName: DbTableName, payloadSchema: PayloadSchemaT, partialPayloadSchema: PartialPayloadSchemaT) {
//     const withTableSchema = BaseUpdatableSetlistPacketSchema.extend({
//         tbl: z.literal(dbTableName),
//     });
//     const updatablePacketSchema = withTableSchema.extend({
//         prev: partialPayloadSchema,
//         next: partialPayloadSchema,
//     } as const);
//     const insertionPacketSchema = withTableSchema.extend({
//         prev: z.null(),
//         next: payloadSchema,
//     });
//     const deletionPacketSchema = withTableSchema.extend({
//         prev: z.object({id: z.string()}),
//         next: z.null(),
//     });
//     const nukePacketSchema = withTableSchema.extend({
//         prev: z.optional(z.null()),
//         next: z.optional(z.null()),
//     });
//     const packetSchema = z.union([
//         updatablePacketSchema,
//         insertionPacketSchema,
//         deletionPacketSchema,
//         nukePacketSchema,
//     ]);
//
//     return {
//         payloadSchema,
//         updatablePacketSchema,
//         insertionPacketSchema,
//         deletionPacketSchema,
//         nukePacketSchema,
//         packetSchema,
//     } as const;
// }

// type afot = z.infer<typeof payloadSchemas["bundle_active"]["deletionPacketSchema"]>;


// function isSetlistPacketIded(packet: SetlistPacket<unknown>): packet is SetlistPacket<Ided> {
//     if (!packet.prev && !packet.next) {
//         return true;
//     }
//     if (packet.prev && ("id" in (packet.prev as Record<string,unknown>))) {
//         return true;
//     }
//     if (packet.next && ("id" in (packet.next as Record<string,unknown>))) {
//         return true;
//     }
//     return false;
// }

export const BasuraProtocol = "basura:";
export const TqkZone = "tqk";
const NologinExchange = `${BasuraProtocol}sys/nologin`;

export type SetlistConnectionStatus = "up" | "dialing" | "closing" | "down" |
    "asleep" | "dead" | "error";

// export const Initiator_Tripleg = "tripleg";
// export const Initiator_Transfer = "bundle_transfer";
// export const Initiator_ScheduledTransfer = "scheduled_bundle_transfer";
// export const Initiator_AgentStub = "agent_stub";
// export const Initiator_TruckStub = "truck_stub";
// export const Initiator_Bundle = "bundle_active";

// export function setlistPacketInitiator(packet: SetlistPacket<any>): string {
//     return packet.tbl;
// }

// export type Comparator<T> = (a: T, b: T) => number;
//
// export const SetlistTable_ScheduledBundleTransfer = "scheduled_bundle_transfer";
// export const SetlistTable_JobStamp = "job_stamp";
// export const SetlistTable_BundleStamp = "bundle_stamp";
// export const SetlistTable_WasteStamp = "waste_stamp";
// export const SetlistTable_AgentStamp = "agent_stamp";
// export const SetlistTable_TruckStamp = "truck_stamp";
// export const SetlistTable_BundleActive = "bundle_active";
// export const SetlistTable_WasteActive = "waste_active";
// export const SetlistTable_WasteBundle = "waste_bundle";
// export const SetlistTable_BundleTransfer = "bundle_transfer";
// export const SetlistTable_Tripleg = "tripleg";
// export const SetlistTable_TriplegStub = "tripleg_stub";
// export const SetlistTable_AgentPresence = "basura:sys/presence";
// export const SetlistTable_TruckCrew = "truck_crew";

interface Posted {
    posted: string;
}

export function cmpPosted<T extends Posted>(a: T, b: T): number {
    const rv = compareAsc(a.posted, b.posted);
    return rv;
}

interface Created {
    created: string;
}

function cmpCreated<T extends Created>(a: T, b: T): number {
    const rv = compareAsc(a.created, b.created);
    return rv;
}

const comparators: Partial<Record<DbTableLabel, Comparator<any>>> = {
    [DbTableLabels.scheduled_bundle_transfer]: cmpScheduledTransfer,
    [DbTableLabels.job_stamp]: cmpPosted,
    [DbTableLabels.bundle_stamp]: cmpPosted,
    [DbTableLabels.waste_stamp]: cmpPosted,
    [DbTableLabels.agent_stamp]: cmpPosted,
    [DbTableLabels.truck_stamp]: cmpPosted,
    [DbTableLabels.bundle_active]: cmpCreated,
    [DbTableLabels.waste_active]: cmpCreated,
    [DbTableLabels.waste_bundle]: cmpCreated,
} as const;

export function getComparator<DbTable extends DbTableLabel>(packet: TableizedPacket<DbTable>): Comparator<DbPayload<DbTable>> | undefined {
    const rv = comparators[packet.tbl];
    if (!rv) {
        console.log(`no comparator for ${packet.tbl}, using id`);
    }
    return rv;
}

// export function uncompressDeltaPacket<T extends Ided>(baseline: T | undefined, packet: SetlistPacket<T>): T | undefined {
//     const isDelta = isDeltaCompressed(packet);
//     let rv: T | undefined;
//     if (isDelta) {
//         if (baseline) {
//             if (packet.prev && packet.next) {
//                 const trans = {prev: packet.prev, next: packet.next};
//                 rv = applyPatch(baseline, trans);
//             } else {
//                 throw new Error(`malformed delta-compressed packet ${JSON.stringify(packet)}`);
//             }
//         }
//     } else {
//         rv = packet.next;
//     }
//     return rv;
// }

interface EntityIds {
    prev?: string;
    next?: string;
}

interface EntityTimestamps {
    prev?: Date;
    next?: Date;
}

// interface SetlistPacketFreshness {
//     prev: boolean;
//     next: boolean;
// }

function entityIds(pkt: WiredSetlistPacket): EntityIds {
    const prev = Ided.safeParse(pkt.prev);
    const next = Ided.safeParse(pkt.next);
    const rv: EntityIds = {};
    if (prev.success) {
        rv.prev = `${pkt.tbl}@${prev.data.id}`;
    }
    if (next.success) {
        rv.next = `${pkt.tbl}@${next.data.id}`;
    }
    return rv;
}

export function tqkFromPathStep<const Verb extends RpcVerb>(pathStep: string): TqKey<Verb> | null {
    try {
        const url = new URL(pathStep);
        if (url.protocol !== BasuraProtocol) {
            return null;
        }
        const fullPath = url.pathname;
        const pathSegs = fullPath.split("/");
        if (pathSegs[0] !== TqkZone) {
            return null;
        }
        const args = Object.fromEntries(url.searchParams.entries());
        // ignore artificial wildcard keys. their only purpose is to get updates
        // to us that we weren't listening to specifically (likely because we didn't
        // know they existed). they will not ever impact the query cache directly.
        // another way to think about this is that if there is no argument to check,
        // we don't care what the schema says. it will error if it is expecting arguments
        // but not seeing them.

        // 2025.08.07 the previous logic of simply returning null here if there are
        // no arguments is hopelessly broken, because it causes all argumentless
        // keys to be ignored. put hasInput on every codegened function block. that
        // way, we can return null if inputs are expected but not present,
        // and still process keys that don't expect input

        const verb = pathSegs[1] as Verb;
        const vmi = RpcVerbMap[verb];

        if (vmi.hasInput) {
            if (isEmpty(args)) {
                return null;
            }

            const rv = vmi.tqkSchema.parse([verb, args]);
            return rv as TqKey<Verb>;
        } else {
            const rv = [verb] as TqKey<Verb>;
            return rv;
        }
    } catch (xc) {
        console.log(`problem parsing ${pathStep} ${JSON.stringify(xc)}`);
        return null;
    }
}

export function hashedTqkSetFromKeyExchanges(kxen: string[]): Map<string, QueryKey> {
    const rv = new Map<string, QueryKey>();
    kxen.forEach(kx => {
        const tqk = tqkFromPathStep(kx);
        if (tqk) {
            rv.set(hashKey(tqk), tqk);
        }
    });
    return rv;
}

//
// type UnwrappedSingle<Envelope, LetterT> = {
//     envelope: Envelope;
//     letter: LetterT;
// }
//
// type UnwrappedMulti<Envelope, LetterT> = {
//     envelope: Envelope;
//     letters: LetterT[];
// };
//
// type Unwrapped<Envelope, LetterT> = UnwrappedSingle<Envelope, LetterT> | UnwrappedMulti<Envelope, LetterT>;
//
// function safeParseWrapped<Envelope extends PropertyKey, LetterZT extends Zoddable>(hina: Record<PropertyKey, unknown>, letterSchema: ZodObject<LetterZT>) {
//     const keys = Object.keys(hina);
//     if (keys.length !== 1) {
//         return {
//             success: false, error: new ZodError([{
//                     code: "custom",
//                     message: "only one envelope allowed",
//                     input: hina,
//                     path: [],
//                 }
//                 ]
//             )
//         } as const;
//     }
//
//     const envelope = keys[0];
//     const payload = hina[envelope];
//     if (R.isArray(payload)) {
//         const zprv = letterSchema.array().transform((val: z.infer<LetterZT>[]) => {
//             return {envelope, letters: val};
//         }).safeParse(payload);
//         return zprv as ZodSafeParseResult<UnwrappedMulti<Envelope, z.infer<LetterZT>>>;
//     } else {
//         const zprv = letterSchema.transform((val: z.infer<LetterZT>) => {
//             return {envelope, letters: val};
//         }).safeParse(payload);
//         return zprv as ZodSafeParseResult<UnwrappedSingle<Envelope, z.infer<LetterZT>>>;
//     }
// }

// export function isDeltaCompressed<Table extends TableLabel>(maybe: SetlistPacket<T>): maybe is DeltaPacket<T> {
//     const rv = "dlta" in maybe && !!maybe.dlta;
//     return rv;
// }

function isNukePacket(wpkt: WiredSetlistPacket) {
    return (!("prev" in wpkt) || !wpkt.prev) && (!("next" in wpkt) || !wpkt.next);
}

export type SetlistPacketConsumer = Listener<WiredSetlistPacket>;

interface SetlistManagerApi {
    getStatus: () => SetlistConnectionStatus;
    listenStatus: (listener: Listener<SetlistConnectionStatus>) => Unlistener;
    getLastError: () => Error | null | undefined;
    listenLastError: (listener: Listener<Error | null | undefined>) => Unlistener;
    listenRawFeed: (listener: Listener<WiredSetlistPacket>) => Unlistener;
    reset: () => void;
}

// const errNoSetlistProvider = "no setlist provider in scope";

const uninitializedApiContext = {
    getStatus: () => "down" as SetlistConnectionStatus,
    listenStatus: () => () => {/**/
    },
    getLastError: () => undefined,
    listenLastError: () => () => {/**/
    },
    listenRawFeed: () => () => {/**/
    },
    reset: () => {/**/
    },
} as const;

const ApiContextKey = createContext<SetlistManagerApi>(uninitializedApiContext);

function useListenRawSetlist() {
    const ctx = useContext(ApiContextKey);
    return ctx.listenRawFeed;
}

export function useSetlistConnectionStatus() {
    const ctx = useContext(ApiContextKey);
    const rv = useSyncExternalStore(ctx.listenStatus, ctx.getStatus);
    return rv;
}

export function useLastSetlistError() {
    const ctx = useContext(ApiContextKey);
    const rv = useSyncExternalStore(ctx.listenLastError, ctx.getLastError);
    return rv;
}

export function useResetSetlist() {
    const ctx = useContext(ApiContextKey);
    return ctx.reset;
}

const resetErrorName = "userInitiatedReset";

function isResetError(maybe?: Error) {
    return isSpecificError(maybe, resetErrorName);
}

const callBackoffOptions = {
    minDelay: 300,
    maxDelay: 10 * 60 * 1000,
    multiplier: 2,
} as const;

export const errOffHook = new Error("off hook");
export const errAlreadyConnected = new Error("already connected");
export const errOutstandingMessage = "outstanding error";
const errNoAbortController = new Error("no abort controller");

interface SetlistFeedManagerProps {
    auther: Authenticator;
    navigate: ReturnType<typeof useNavigate>;
    mama: KingBasura;
}

class SetlistFeedManager {
    constructor(props: SetlistFeedManagerProps) {
        this.auther = props.auther;
        this.mama = props.mama;
        this.navigate = props.navigate;

        this._status = "down";
        this._statusListeners = [
            // (connstat: SetlistConnectionStatus) => {
            //     if (connstat === "down") {
            //         this.switchOutlets();
            //     }
            // }
        ];
        this._currentDelay = 0;
        this._errorListeners = [];
        this._autoRedial = true;
        this._packetListeners = [
            (packet: WiredSetlistPacket) => {
                if (packet.tqks.includes(NologinExchange)) {
                    void this.auther.performLogout()
                        .then(() => this.navigate({to: "/login", replace: true}));
                }
            }
        ];
    }

    // getIsAuthenticated: () => boolean;
    // switchOutlets: () => void;

    auther: Authenticator;
    mama: KingBasura;
    navigate: ReturnType<typeof useNavigate>;

    getStatus() {
        return this._status;
    }

    setStatus(next: SetlistConnectionStatus) {
        const prev = this._status;
        if (prev !== next) {
            // console.log(`connstat change ${prev} -> ${next}`)
            this._status = next;
            this._statusListeners.forEach((listener) => {
                listener(next);
            });
        }
    }

    getLastError() {
        return this._lastError;
    }

    clearLastError() {
        delete this._lastError;
        if (this._status === "error") {
            this.setStatus("down");
        }
    }

    raiseError(err: Error) {
        if (isAbortError(err) || isResetError(err)) {
            this.setStatus("down");
        } else {
            this._lastError = err;
            this._errorListeners.forEach(listener => {
                listener(err);
            });
            this.setStatus("error");
        }
    }

    getAutoRedial() {
        return this._autoRedial;
    }

    setAutoRedial(redialp: boolean) {
        this._autoRedial = redialp;
    }

    canDial() {
        if (!this.auther.getJwt()) {
            return errUnauthenticated
        }
        if (!!this._abortController || !!this._activeTimeout) {
            return errOffHook;
        }
        if (this._status === "up") {
            return errAlreadyConnected;
        }
        if (this._lastError) {
            return new Error(errOutstandingMessage, {cause: this._lastError});
        }
        return null;
    }

    dial() {
        this.clearLastError();
        const err = this.canDial();
        if (err) {
            return;
        }

        if (this._status !== "dialing") {
            this.setStatus("dialing");
        }

        if (!this._currentDelay) {
            this._currentDelay = callBackoffOptions.minDelay;
        } else {
            this._currentDelay = this._currentDelay * callBackoffOptions.multiplier;
        }
        if (this._currentDelay > callBackoffOptions.maxDelay) {
            this.setStatus("dead");
            return;
        }

        const self = this;
        console.log(`scheduling next check ${this._currentDelay.toString()}`)
        this._activeTimeout = setTimeout(() => {
            console.log("dial timeout fires");
            delete self._activeTimeout;
            if (self._status === "up") {
                delete this._currentDelay;
                return;
            }

            if (self._abortController) {
                self._abortController.abort();
                delete self._abortController;
            }

            // this structure is pretty intricate. clearing the last error sets our status
            // to down.
            if (self._status === "error") {
                self.clearLastError();
            }

            // so if we either were already down or just went down, we need to shift to
            // dialing
            if (self._status === "down") {
                self.setStatus("dialing");
            }

            // which means we will now be in dialing if (a) we already were but the last
            // try has timed out without error notification, (b) we autocleared an error,
            // or (c) we started out down when call got called. if there is any other possible
            // state, it will terminate the establishment backoff chain.
            if (self._status === "dialing") {
                self.dial();
            }
        }, this._currentDelay);

        this._abortController = new AbortController();
        this.mama.setlists(this.mothershipRequestOptions());
    }

    private performHangup(finalConnstat: SetlistConnectionStatus) {
        this.setStatus("closing");
        if (this._activeTimeout) {
            clearTimeout(this._activeTimeout);
            delete this._activeTimeout;
        }
        if (this._abortController) {
            this._abortController.abort();
            delete this._abortController;
        }
        this.setStatus(finalConnstat);
        delete this._currentDelay;
    }

    hangup() {
        this.performHangup("down");
    }

    sleep() {
        this.performHangup("asleep");
    }

    reset() {
        this.clearLastError();
        this.hangup();
        this.auther.changeOutletSlug();
        this.clearLastError();
        this.dial();
    }

    listenStatus(listener: Listener<SetlistConnectionStatus>): Unlistener {
        return listenerListAdd(this._statusListeners, listener);
    }

    listenErrors(listener: Listener<Error | null | undefined>): Unlistener {
        return listenerListAdd(this._errorListeners, listener);
    }

    listenPackets(listener: SetlistPacketConsumer): Unlistener {
        return listenerListAdd(this._packetListeners, listener);
    }

    // private verifyCanScheduleCall() {
    //     if (!!this._abortController || !!this._activeTimeout) {
    //         throw offHookError;
    //     }
    //     if (this._status === "up") {
    //         throw alreadyConnectedError;
    //     }
    //     if (this._lastError) {
    //         throw new Error(outstandingErrorMessage, {cause: this._lastError});
    //     }
    // }

    private mothershipRequestOptions() {
        if (!this._abortController) {
            throw errNoAbortController;
        }
        const self = this;
        const rv: WebrpcStreamOptions<SetlistPacketResult> = {
            onOpen: () => {
                // console.log("setlist connection opened");
                self.setStatus("up");
            },
            onClose: () => {
                // console.log("setlist connection closed");
                self.setStatus("down");
            },
            onError: (err) => {
                if (isAbortError(err) || isResetError(err)) {
                    // console.log(`graceful abort ${err.name}`);
                    // self.setStatus("down");
                    // delete self._abortController;
                } else if (err instanceof WebrpcStreamLostError) {
                    // console.log("setlist stream lost");
                    if (self._autoRedial) {
                        self.hangup();
                        self.clearLastError();
                        self.dial();
                    } else {
                        self.raiseError(err);
                    }
                } else {
                    console.log(`unexpected webrpc error ${err.message}`);
                    self.raiseError(err);
                    // if (self._abortController) {
                    //     self._abortController.abort();
                    //     delete self._abortController;
                    // }
                }
            },
            // TODO there seems to be a webrpc bug here that wraps our packet in a "response"
            // object, in contradiction of what the types say.
            onMessage: (msg) => {
                const wiredPacket = (msg as unknown as { response: SetlistPacketResult }).response.packet;
                //               console.log("setlist packet received " + JSON.stringify(wiredPacket));
                self._packetListeners.forEach(listener => {
                    listener(wiredPacket);
                });
            },
            signal: self._abortController!.signal,
        };
        return rv;
    }

    private _status: SetlistConnectionStatus;
    private _statusListeners: Listener<SetlistConnectionStatus> [];
    private _abortController ?: AbortController;
    private _activeTimeout ?: number | NodeJS.Timeout;
    private _currentDelay ?: number;
    private _lastError ?: Error;
    private _errorListeners: Listener<Error> [];
    private _autoRedial: boolean;
    private _packetListeners: Listener<WiredSetlistPacket>[] = [];
}

// function applyPatch<T extends Ided>(prev: T, trans: Transition<Partial<T>>): Partial<T> {
//     if (prev.id !== trans.prev.id || prev.id !== trans.next.id) {
//         throw new Error(`cannot patch ${JSON.stringify(trans)} off ${JSON.stringify(prev)}`);
//     }
//     const next = structuredClone(prev) as Record<string, any>;
//     for (const k in trans.prev) {
//         if (k !== "id") {
//             // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
//             delete (next[k]);
//         }
//     }
//     for (const k in trans.next) {
//         if (k !== "id") {
//             next[k] = trans.next[k];
//         }
//     }
//     const rv = next as T;
//     return rv;
// }

// type SealedLetter<Envelope extends PropertyKey, LetterT> = Record<Envelope, LetterT>;

// function replaceLetter<const Envelope extends PropertyKey, const LetterT>(orig: SealedLetter<Envelope, LetterT>, nv: LetterT): SealedLetter<Envelope, LetterT> {
//     const k0 = Object.keys(orig)[0];
//     const rv = Object.fromEntries([[k0, nv]]) as SealedLetter<Envelope, LetterT>;
//     return rv;
// }
//
// function patchSingleLetter<Envelope extends string, LetterT extends Ided>(orig: SealedLetter<Envelope, LetterT>, trans: Transition<Partial<LetterT>>): SealedLetter<Envelope, Partial<LetterT>> {
//     const k0 = Object.keys(orig)[0] as Envelope;
//     const prevLetter = orig[k0];
//     const nextLetter = applyPatch(prevLetter, trans);
//     const next = replaceLetter(orig, nextLetter);
//     return next;
// }
//
// function patchMultiLetter<Envelope extends string, LetterElemT extends Ided>(orig: SealedLetter<Envelope, LetterElemT[]>, trans: Transition<Partial<LetterElemT>>): SealedLetter<Envelope, Partial<LetterElemT>[]> | undefined {
//     const k0 = Object.keys(orig)[0] as Envelope;
//     const prevLetter = orig[k0];
//     const wantedId = trans.next.id;
//     if (!wantedId) {
//         throw new Error(`malformed transition ${JSON.stringify(trans)}`);
//     }
//     const xix = prevLetter.findIndex(maybe => maybe.id === wantedId);
//     if (xix === -1) {
//         return undefined;
//     }
//     const nextElem = applyPatch(prevLetter[xix], trans);
//     const nextLetter: Partial<LetterElemT>[] = structuredClone(prevLetter);
//     nextLetter[xix] = nextElem;
//     const next = replaceLetter(orig, nextLetter);
//     return next;
// }

// export function updateTqFromSetlistPacket<const Verb extends "WasteById">(tqc: QueryClient, tqk: TqKey<Verb>, rawPacket: WiredSetlistPacket) {
//     const verb = tqk[0];
//     const vrec = RpcVerbMap[verb];
//     type CacheEntryT = z.infer<typeof vrec["returnSchema"]>;
//     const multiplicity = vrec.multiplicity;
//     const deltaSchema = RpcTypeMap[vrec.returnLetterTypeName].deltaTransitionSchema;
//     const deltaZprv = deltaSchema.safeParse(rawPacket);
//     const cacheEntry = tqc.getQueryData<CacheEntryT>(tqk);
//     const cachePayload = cacheEntry ? cacheEntry[vrec.returnEnvelope] : undefined;
//     const seal = (letter: unknown) => vrec.returnSchema.parse(Object.fromEntries([[vrec.returnEnvelope, letter]]));
//
//     // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
//     if (multiplicity === "single") {
//         const patchedNext = !!cachePayload && deltaZprv.success
//             ? vrec.setlistPayloadSchema.parse(applyPatch(cachePayload, deltaZprv.data))
//             : undefined;
//
//         if (!("next" in rawPacket) || !rawPacket.next
//             || (deltaZprv.success && !patchedNext)) {
//             return tqc.invalidateQueries({queryKey: tqk});
//         }
//         // at this point, three possible things can be happening:
//         // - an addition
//         // - a full replace
//         // - a delta that has been inflated
//         const next = patchedNext ?? vrec.setlistPayloadSchema.parse(rawPacket.next);
//         const sealedNext = seal(next);
//         return tqc.setQueryData<CacheEntryT>(tqk, sealedNext);
//
//         // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
//     } else if (multiplicity === "multi") {
//         if (isNukePacket(rawPacket)) {
//             return tqc.invalidateQueries({queryKey: tqk});
//         }
//
//         if ("prev" in rawPacket && rawPacket.prev && !("next" in rawPacket)) {
//             // a delete
//             const prevId = IdedSchema.parse(rawPacket.prev).id;
//             if (cachePayload) {
//                 const next = cachePayload
//                     .filter(maybe => maybe.id !== prevId);
//                 const sealedNext = seal(next);
//                 return tqc.setQueryData<CacheEntryT>(tqk, sealedNext);
//             }
//         } else {
//             // at this point, next must exist and we have the same three-pronged situation.
//             // we need set behavior, so we don't blindly add things that we are told to add.
//             // so basically we are updating our entry with the relevant id or adding a new
//             // one if we don't find one.
//
//             const wantedId = IdedSchema.parse(rawPacket.next).id;
//             let found = false;
//             const next: z.infer<typeof vrec["returnLetterSchema"]> = [];
//             for (const elem of (cachePayload ?? [])) {
//                 if (elem.id === wantedId) {
//                     const newElem = vrec.setlistPayloadSchema.parse(
//                         deltaZprv.success
//                             ? applyPatch(elem, deltaZprv.data)
//                             : rawPacket.next);
//                     next.push(newElem);
//                     found = true;
//                 } else {
//                     return elem;
//                 }
//             }
//
//             if (!found) {
//                 if (deltaZprv.success) {
//                     // no bueno, we have nothing to patch from
//                     return tqc.invalidateQueries({queryKey: tqk});
//                 }
//                 const newElem = vrec.setlistPayloadSchema.parse(rawPacket.next);
//                 next.push(newElem);
//             }
//
//             const sealedNext = seal(next);
//             return tqc.setQueryData<CacheEntryT>(tqk, sealedNext);
//         }
//     }
// }

function canVerbConsumeSetlistPacket(maybe: string): maybe is keyof typeof setlistPacketConsumersByVerb {
    return maybe in setlistPacketConsumersByVerb;
}

function SetlistTqkUpdater({children}: PropsWithChildren) {
    const lastSetlistUpdateTimestampsRef = useRef(new Map<string, Date>());
    const tqc = useQueryClient();
    const bomb = useBomb();

    const getLastSetlistUpdateTimestamps = useCallback((packet: WiredSetlistPacket) => {
        const lastSetlistUpdateByEntityId = lastSetlistUpdateTimestampsRef.current;
        const eids = entityIds(packet);
        const rv: EntityTimestamps = {};
        if (eids.prev) {
            rv.prev = lastSetlistUpdateByEntityId.get(eids.prev);
        }
        if (eids.next) {
            rv.next = lastSetlistUpdateByEntityId.get(eids.next);
        }
        if (!rv.prev && !rv.next) {
            return null;
        }
        return rv;
    }, []);

    const isSetlistPacketFresh = useCallback((packet: WiredSetlistPacket) => {
        // nuke packets must always be considered fresh
        if (isNukePacket(packet)) {
            return {prev: true, next: true};
        }

        const lastUpdated = getLastSetlistUpdateTimestamps(packet);

        const rv = {
            prev: !!packet.prev && (!lastUpdated?.prev || !isBefore(packet.asof, lastUpdated.prev)),
            next: !!packet.next && (!lastUpdated?.next || !isBefore(packet.asof, lastUpdated.next)),
        };

        return rv;
    }, [getLastSetlistUpdateTimestamps]);

    const setLastSetlistUpdateTimestamps = useCallback((packet: WiredSetlistPacket) => {
        const lastSetlistUpdateByEntityId = lastSetlistUpdateTimestampsRef.current;
        const eids = entityIds(packet);
        const lastUpdated = getLastSetlistUpdateTimestamps(packet);
        if (!!packet.prev && !!eids.prev && (!lastUpdated?.prev || isAfter(packet.asof, lastUpdated.prev))) {
            lastSetlistUpdateByEntityId.set(eids.prev, new Date(packet.asof));
        }
        if (!!packet.next && !!eids.next && (!lastUpdated?.next || isAfter(packet.asof, lastUpdated.next))) {
            lastSetlistUpdateByEntityId.set(eids.next, new Date(packet.asof));
        }
    }, [getLastSetlistUpdateTimestamps]);

//     const updateCachedSetlist = useCallback(<Table extends TableLabel, >(rawpkt: TableizedPacket<Table>, queryKey: QueryKey) => {
//         const nukePacketZprv = NukePacketSchema.safeParse(rawpkt);
//         if (nukePacketZprv.success) {
//             void tqc.invalidateQueries({queryKey});
//             return;
//         }
//
//         const payloadSchema = dbPayloadSchemas[rawpkt.tbl];
//
//         // there may be a need to invalidate in the event of stale packets, if we ever
//         // go to a lossy diff system, because we may not have the requisite prev yet
//         // 2025.03.23 that now happens
//         const queryData = tqc.setQueryData(
//             queryKey, (rawCached: Record<string, unknown> | undefined) => {
//                 // TODO this causes a problem with delta compression in the instance
//                 // where dispatch is relying on a "by id" fetcher, but nobody is actually
//                 // sitting on that query. we will never seed it, and updates against it
//                 // won't get propagated.
//                 if (rawCached === undefined) {
//                     return undefined;
//                 }
//
//                 const cachedZprv
//                     = safeParseWrapped'(rawCached, payloadSchema);
//
//
//                 // we assume that every query returning a setlist returns only that setlist.
//                 // we don't know what it's called yet.
//                 const slot = getLoneKey(cached);
//                 const prev = cached[slot];
//
//                 const addZprv = safeParseAddPacket(rawpkt);
//                 const delZprv = safeParseDelPacket(rawpkt);
//                 const replZprv = safeParseReplacePacket(rawpkt);
//                 const deltaZprv = safeParseDeltaPacket(rawpkt);
//
//                 if (isSetlistTqkSingle(queryKey)) {
//                     if (deltaZprv.success) {
//                         const trans = {prev: deltaZprv.data.prev, next: deltaZprv.data.next} as const;
//                         next = applyPatch(prev, trans);
//                     } else if (addZprv.success) {
//                         next = addZprv.data.next;
//                     } else if (replZprv.success) {
//                         next = replZprv.data.next;
//                     } else {
//                         tqc.invalidateQueries({queryKey}).catch(bomb);
//                         return undefined;
//                     }
//                 )
//
//                     // do we have a duty to figure out whether prev matches?
//                     // currently, we just completely ignore it and set our cached
//                     // value to whatever comes through in next
//                     const rv: Record<string, Ided> = {};
//
//                     rv[slot] = next;
//                     return rv;
//                 } else {
//                     const xset = (cached[slot] ?? []) as Payload<Table>[];
//                     let next: Payload<Table>[];
//                     if (addZprv.success) {
//                         // using unionWith prevents multiple adds with the same
//                         // entry from tribblizing
//                         const n = addZprv.data.next;
//                         next = unionWith<Payload<Table>>([addZprv.data.next], xset, isEqualById);
//                     } else if (!!packetPrev && !packetNext) {
//                         next = xset.filter(maybe => maybe.id !== packetPrev.id);
//                     } else {
//                         if (!packetPrev || !packetNext || packetPrev.id !== packetNext.id) {
//                             throw new Error(`malformed setlist packet ${JSON.stringify(packet)}`);
//                         }
//                         let found = false;
//                         next = xset.map(maybe => {
//                             if (maybe.id === packetNext.id) {
//                                 found = true;
//                                 return packetNext;
//                             } else {
//                                 return maybe;
//                             }
//                         });
//                         // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
//                         if (!found) {
//                             next.push(packetNext)
//                         }
//                     }
//
//                     const cmper = getSetlistComparator(packet);
//                     if (cmper) {
//                         next.sort(cmper);
//                     }
//
//                     const rv: Record<string, Ided[]> = {};
//                     rv[slot] = next;
//                     return rv;
//                 }
//             }, []);
//         // all tqks now come from the server
// //        updateById(packet);
//         // but we still need to update our local notion of freshness
//         setLastSetlistUpdateTimestamps(rawpkt)
//     }, [bomb, setLastSetlistUpdateTimestamps, tqc]);

    const updateCachedSetlists = useCallback((packet: WiredSetlistPacket) => {
        const freshness = isSetlistPacketFresh(packet);
        if (freshness.prev || freshness.next) {
            packet.tqks.forEach(qx => {
                const tqk = tqkFromPathStep(qx);
                if (tqk) {
                    console.log(`updating cached setlist ${qx} packet ${packet.pkid}`);
                    const verb = tqk[0];
                    if (canVerbConsumeSetlistPacket(verb)) {
                        try {
                            setlistPacketConsumersByVerb[verb](tqc, tqk, packet);
                        } catch (xc: unknown) {
                            bomb(xc);
                        }
                    }
                }
            });
            setLastSetlistUpdateTimestamps(packet);
        } else {
            // console.log(`ignoring stale setlist packet ${JSON.stringify(packet)}`);
        }
    }, [bomb, isSetlistPacketFresh, setLastSetlistUpdateTimestamps, tqc]);

    const subscribeToFeed = useListenRawSetlist();

    useEffect(() => {
        return subscribeToFeed(updateCachedSetlists);
    }, [subscribeToFeed, updateCachedSetlists]);

// const connstat = useSetlistConnectionStatus();
// const isFed = connstat === "up";
// useEffect(() => {
//     tqc.setDefaultOptions({
//         queries: {
//             throwOnError: true,
//             staleTime: isFed ? FED_STALE_TIME : UNFED_STALE_TIME,
//         }
//     });
// }, [tqc]);

    return <>{children}</>;
}

export function SetlistFeedProvider({children}: PropsWithChildren) {
    const auther = useAuthenticator();
    const {data: prefs} = usePreferences();
    const sleepSecs = prefs?.sleepSeconds;
    const sleepMillis = sleepSecs ? sleepSecs * 1000 : Infinity;
    const mama = useMothership();
    const navigate = useNavigate();
    const managerRef = useRef<SetlistFeedManager>(
        new SetlistFeedManager({mama, auther, navigate}));
    useEffect(() => {
        const resetEventListener = () => {
            managerRef.current.reset();
        };
        document.addEventListener(fullResetEventType, resetEventListener);
        return () => {
            document.removeEventListener(fullResetEventType, resetEventListener);
        }
    }, []);
    const [apiContext, setApiContext] = useState<SetlistManagerApi>(uninitializedApiContext);
    useEffect(() => {
        setApiContext(prev => {
            if (prev === uninitializedApiContext) {
                return {
                    getStatus: managerRef.current.getStatus.bind(managerRef.current),
                    listenStatus: (listener: Listener<SetlistConnectionStatus>) => {
                        return managerRef.current.listenStatus(listener);
                    },
                    getLastError: managerRef.current.getLastError.bind(managerRef.current),
                    listenLastError: (listener: Listener<Error | null | undefined>) => {
                        return managerRef.current.listenErrors(listener);
                    },
                    listenRawFeed: (listener: Listener<WiredSetlistPacket>) => {
                        return managerRef.current.listenPackets(listener);
                    },
                    reset: managerRef.current.reset.bind(managerRef.current),
                }
            } else {
                return prev;
            }
        });
    }, []);

    useEffect(() => {
        const mgr = managerRef.current;
//        if (mgr.getAutoRedial() && mgr.getStatus() === "down") {
        mgr.dial();
        //      }

        return () => {
            mgr.hangup();
        };
    }, []);

    const isIdle = useIdle(sleepMillis);

    useEffect(() => {
        if (isIdle && managerRef.current.getStatus() === "up") {
            managerRef.current.sleep();
        }

        if (!isIdle && managerRef.current.getStatus() !== "up") {
            managerRef.current.dial();
        }
    }, [isIdle]);

    return <ApiContextKey value={apiContext}>
        <SetlistTqkUpdater>
            {children}
        </SetlistTqkUpdater>
    </ApiContextKey>;
}

export function SetlistConnectionStatusIcon() {
    const setlistConnectionStatus = useSetlistConnectionStatus();
    return <Veiled child={() =>
        <FontAwesomeIcon
            icon={setlistConnectionStatus === "up"
                ? faLink : faSignalStreamSlash}
            beatFade={setlistConnectionStatus === "dialing" || setlistConnectionStatus === "closing"}
            size="2x"/>
    }
                   topcoatGradientPalette="danger" variant="solid"
                   lifted={setlistConnectionStatus !== "dead"}
    />
}

